import React, { useEffect } from 'react';

function getPreviewSrc(image) {
    if (!image) return '';
    if (typeof image?.src === 'string' && image.src) return image.src;
    if (image instanceof Blob) {
        try {
            return URL.createObjectURL(image);
        } catch (e) {
            return '';
        }
    }
    return '';
}

function SingleImageUpload({ setDirectUpload, directUpload, index, image, setSelectedImage, selectedImage, setEditedImageIndex, toggleStates, setToggleStates }) {
    const toggleId = `toggle-${index}`;
    const isChecked = toggleStates[index] || false;
    const previewSrc = getPreviewSrc(image);

    //set default toggle state
    useEffect(() => {
        if (typeof toggleStates[index] === 'undefined') {
            const updatedToggleStates = [...toggleStates];
            updatedToggleStates[index] = false;
            setToggleStates(updatedToggleStates);
        }
    }, []);

    //handle image type of toggle buttons
    const handleToggleChange = () => {
        const updatedToggleStates = [...toggleStates];
        updatedToggleStates[index] = !updatedToggleStates[index];
        setToggleStates(updatedToggleStates);
    };

    //remove image and its toggle state
    const handleRemoveImage = (index) => {
        const updatedToggleStates = [...toggleStates];
        updatedToggleStates.splice(index, 1);
        setToggleStates(updatedToggleStates);
        const updatedSelectedImage = [...selectedImage];
        updatedSelectedImage.splice(index, 1);
        setSelectedImage(updatedSelectedImage);
    };

    return (
        <li>
            <div>
                <div className="imgWrap">
                    {previewSrc ? (
                        <img src={previewSrc} className="imgFluid" alt={`Case image ${index + 1}`} />
                    ) : (
                        <div className="imgMissing">Image unavailable</div>
                    )}
                </div>
                <div className="actionsWrap">
                    <button type="button" className="btn btnPrimary" onClick={() => {
                        setDirectUpload(false);
                        setEditedImageIndex(index);
                    }}>Edit</button>
                    <button type="button" className="btn btnDanger" onClick={() => handleRemoveImage(index)}>Remove image</button>
                </div>
                <div className="imageTypeToggle">
                    <input type="checkbox" className="toggle" id={toggleId} checked={isChecked} onChange={handleToggleChange} />
                    <label htmlFor={toggleId}>
                        <span className="on">Post Op</span>
                        <span className="off">Pre-Op</span>
                    </label>
                </div>
            </div>
        </li>
    );
}

export default SingleImageUpload;
